import { useModal } from "@/Contexts";
import { pdfType } from "@/Utils/fileValidation";
import { Button } from "@/components/button";
import type { LibraryFile } from "@/pages/library_v2/components/filesView/types";
import { useTrans } from "@/translations";

import { useMemo } from "react";

type Props = {
  file: LibraryFile;
  onDownload: (file: LibraryFile) => void;
};

export const PreviewFileModal: React.FC<Props> = ({
  file,
  onDownload,
}: Props) => {
  const { t } = useTrans();
  const { hideModal } = useModal();

  const isPdf = useMemo(() => {
    const fileExtension = file.format.toLowerCase();

    return pdfType.extensions.includes(fileExtension);
  }, [file]);
  return (
    <div className="absolute top-[2.5%] left-[2.5%] h-[95%] w-[95%] bg-white p-4">
      <div className="relative flex w-full items-center justify-between px-4">
        <h1 className="font-signifier text-2xl">{file.name}</h1>
        <div>
          <Button
            label={t("library:downloadDocumentButton")}
            className="mx-4 px-4 py-2"
            onClick={() => {
              onDownload(file);
              hideModal();
            }}
          />
          <Button
            label={t("actions:close")}
            className="mx-4 px-4 py-2"
            onClick={hideModal}
            color="secondary"
          />
        </div>
      </div>
      <div className="relative mt-4 flex h-[95%] w-full items-center justify-center overflow-scroll">
        <div className="relative flex h-full w-full items-center justify-center">
          {isPdf ? (
            <iframe
              src={`${file.url}#toolbar=0`}
              width="100%"
              height="100%"
            ></iframe>
          ) : (
            <img src={file.url} className="max-h-[95%] max-w-[95%]" />
          )}
        </div>
      </div>
    </div>
  );
};
